import type { ComponentProps } from "react";
import images from "./image-assets.json";

export type ImageAssetName = keyof typeof images;
type Props = Omit<ComponentProps<"img">, "src" | "srcSet" | "width" | "height" | "alt"> & {
  asset: ImageAssetName;
  alt: string;
  sizes: string;
};

export function ResponsiveImage({ asset, ...props }: Props) {
  const image = images[asset];
  const variants: readonly number[] = image.variants;
  const srcSet = variants.length
    ? [
      ...variants.map((width) => `/images/${asset}-${width}.webp ${width}w`),
      // Include the existing native source without duplicating or enlarging it.
      ...(!variants.includes(image.width) ? [`${image.src} ${image.width}w`] : []),
    ].join(", ")
    : undefined;
  return (
    <img {...props} src={image.src} srcSet={srcSet} width={image.width} height={image.height} />
  );
}
